import { faFileLines, faReceipt } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardMenu } from "../menus/StandardMenu"
import { StandardMenuItem } from "../menus/StandardMenuItem"

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onPackingSlip: () => void
    onReceipt: () => void
}>

export function OrderDocumentsMenu({ anchorEl, onClose, onPackingSlip, onReceipt }: Props) {
    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <StandardMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <StandardMenuItem icon={faFileLines} onClick={runAndClose(onPackingSlip)}>
                <LocalizedStrict id="meeting-service-table-production-slip-button">
                    <span>Packing slip</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <StandardMenuItem icon={faReceipt} onClick={runAndClose(onReceipt)}>
                <LocalizedStrict id="user-home-canteen-upcoming-orders-receipt-item">
                    <span>Receipt</span>
                </LocalizedStrict>
            </StandardMenuItem>
        </StandardMenu>
    )
}
